import React from 'react'
import './About.css'
import resumeIcon from '../vendor/file.png'
import downIcon from '../vendor/icons8-low-importance-48.png'
import { useEffect } from 'react'
import linkedin from '../vendor/icons8-linkedin-48.png'
import github from '../vendor/icons8-github-48.png'
import hackerrank from '../vendor/icons8-hackerrank-64.png'
import instagram from '../vendor/icons8-instagram-old-32.png'
import resume from '../vendor/HarshitaSinghResume.pdf'
import {
    Link
} from "react-router-dom";


function About() {

    useEffect(() => {
        document.title = "About / Harshita Singh — Design & Development"
    }, []);

    return (
        <div className="about">
            <h1 className="about__intro">Hello! I'm Harshita Singh.</h1>
            <hr className="about__hrFirst" />
            <div className="about__section">
                <div className="about__col">
                    <h3>I'm a developer</h3>
                    <p>Passionate about UI and front-end development; building responsive web sites and apps with handcrafted HTML, CSS and JavaScript.</p>
                </div>
                <div className="about__col">
                    <h3>I'm also a designer—illustrator</h3>
                    <p>Based in Kanpur, who loves typography and graphic design. Providing art direction for web and illustration projects.</p>
                    <h3>Some skills</h3>
                    <p>Adobe Illustrator <span>/</span> HTML5 <span>/</span> CSS3 <span>/</span> Javascript <span>/</span> jQuery <span>/</span> React JS <span>/</span> Figma <span>/</span> Firebase <span>/</span> MySQL <span>/</span> MongoDB <span>/</span> Bootstrap <span>/</span> Wordpress <span>/</span> Flask <span>/</span> MS Office <span>/</span> Git <span>/</span> GitHub <span>/</span> Python <span>/</span> C <span>/</span> C++</p>
                </div>
                <div className="about__col">
                    <h3>CV</h3>
                    <div className="about__resumeDiscs">
                        <a className="about__resumeLink" href={resume} target="_blank">
                            <div className="about__container">
                                <div className="about__imageContainer">
                                    <img src={resumeIcon} className="about__image" />
                                    <small>VIEW &nbsp;CV</small>
                                </div>
                                <div className="about__overlay">
                                    <div className="about__hoverIcon">
                                        <img src={downIcon} />
                                    </div>
                                </div>
                            </div>
                        </a>
                        <a className="about__resumeLink" href={resume} download={resume}>
                            <div className="about__container">
                                <div className="about__imageContainer">
                                    <img src={resumeIcon} className="about__image" />
                                    <small>DOWNLOAD</small>
                                </div>
                                <div className="about__overlay">
                                    <div className="about__hoverIcon">
                                        <img src={downIcon} />
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <hr className="about__hrSecond" />
            <div className="about__section">
                <div className="about__col">
                    <h3>Education</h3>
                    <p>B. Tech (CSE) — Harcourt Butler Technical University, Kanpur / “2019 - Present”</p>
                    <p>12th (Science) — Mariampur Sr. Sec. School, Kanpur / 90% / “2018 - 2019”</p>
                    <p>10th — Mariampur Sr. Sec. School, Kanpur / 10.00 CGPA / “2016 - 2017”</p>
                </div>
                <div className="about__col">
                    <h3>Work Experience</h3>
                    <p>Web Development Internship — The Sparks Foundation / “August 2021”</p>
                    <p>Participant — HackZurich / "September 2021”</p>
                </div>
                <div className="about__col">
                    <h3>Summary</h3>
                    <p>Pre final year undergraduate at HBTU, Kanpur, pursuing B. Tech in Computer Science and Engineering with a keen interest in learning new technologies.</p>
                    <p>Location — Kanpur, Uttar Pradesh</p>
                    <p>Freelance — Available</p>
                    <p>Age — 20</p>
                    <h3>Interests</h3>
                    <p>Reading ∙ Travelling ∙ User Interfaces ∙ Art ∙ Fitness ∙ Learning </p>
                </div>
            </div>
            <hr className="about__hrSecond" />
            <div className="about__section">
                <div className="about__col">
                    <h3>Get in touch</h3>
                    <a className="about__email" href="mailto:sharshita352@gmail.com"><p>s.harshita352@gmail.com</p></a>
                    <p>+918687354182</p>
                    <div className="about__socialMediaIcons">
                        <a target="_blank" href="https://www.linkedin.com/in/harshita-singh-6676711a9/"><img src={linkedin} /></a>
                        <a target="_blank" href="https://github.com/harshitaSingh11"><img src={github} /></a>
                        <a target="_blank" href="https://www.hackerrank.com/sharshita352"><img src={hackerrank} /></a>
                        <a target="_blank" href="https://www.instagram.com/_harshita.singh__/"><img src={instagram} /></a>
                    </div>
                </div>
                <div className="about__col">
                    <h3>I'm always interested about cool stuff.</h3><p>Are you minding a project?<br />Let's talk.</p>
                </div>
                <div className="about__col">
                </div>
            </div>
        </div>
    )
}

export default About
